import { GUFDetail } from "@nens/brostar/openapi-client";
import {
  DesignInstallation,
  EditGUFStartRegistrationTask,
  displacementDirectionOptions,
  gufDeliveryContextOptions,
  indicationYesNoOptionsType,
  legalTypeOptions,
  qualityRegimeOptionsType,
  usageTypeOptions,
} from "@nens/brostar/uploadapi-client";
import { toDateString } from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

const displacementDirectionTypes = displacementDirectionOptions.map((option) => option.value);

const validUsageTypes = usageTypeOptions.map((option) => option.value);

const normalizeUsageTypes = (
  value: unknown
): EditGUFStartRegistrationTask["sourcedocumentData"]["secondaryUsageTypes"] => {
  if (!Array.isArray(value)) return [];

  return value
    .map((part) => (typeof part === "string" ? part : ""))
    .filter((part): part is (typeof validUsageTypes)[number] =>
      validUsageTypes.includes(part as (typeof validUsageTypes)[number])
    );
};

export const convertGUFToEditTask = (
  guf: GUFDetail,
  designInstallations: DesignInstallation[]
): EditGUFStartRegistrationTask => {
  const licensedQuantity = Object.entries(guf.licensedQuantities ?? {}).map(([key, item]) => ({
    licensedInOut: isValidEnum(displacementDirectionTypes, item.licensed_in_out)
      ? (item.licensed_in_out as (typeof displacementDirectionTypes)[number])
      : "onttrekken",
    maximumPerHour: item.maximum_per_hour ? item.maximum_per_hour.value ?? "" : "",
    maximumPerDay: item.maximum_per_day ? item.maximum_per_day.value ?? "" : "",
    maximumPerMonth: item.maximum_per_month ? item.maximum_per_month.value ?? "" : "",
    maximumPerQuarter: item.maximum_per_quarter ? item.maximum_per_quarter.value ?? "" : "",
    maximumPerYear: item.maximum_per_year ? item.maximum_per_year.value ?? "" : "",
  }));
  return {
    metadata: {
      broId: guf.broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, guf.qualityRegime),
      deliveryAccountableParty: guf.deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      objectIdAccountableParty: guf.internalId ?? "",
      deliveryContext: isValidEnum(
        gufDeliveryContextOptions.map((option) => option.value),
        guf.deliveryContext
      ),
      startTime: toDateString(guf.startTime),
      identificationLicence: guf.identificationLicence ?? "",
      legalType: isValidEnum(
        legalTypeOptions.map((option) => option.value),
        guf.legalType
      ),
      primaryUsageType: isValidEnum(
        usageTypeOptions.map((option) => option.value),
        guf.primaryUsageType
      ),
      secondaryUsageTypes: normalizeUsageTypes(guf.secondaryUsageTypes),
      humanConsumption: isValidEnum(indicationYesNoOptionsType, guf.humanConsumption),
      licensedQuantities: licensedQuantity,
      designInstallations,
    },
  };
};
